import * as React from 'react';
import classnames from 'classnames';
import registrationForm from './formConfigs/RegistrationFormConfig';
import LoginForm from './forms/LoginForm';
import RegistrationForm from './forms/RegistrationForm';
import styles from './modals.styl';
import baseModalStyles from '../BaseModal.styl';
class LoginRegistrationModal extends React.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "loginFormSubmitted", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "registrationFormSubmitted", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "onChangeToLogin", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => this.setState(() => ({
                currentTab: 1
            }))
        });
        Object.defineProperty(this, "onChangeToCreateAccount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => this.setState(() => ({
                currentTab: 0
            }))
        });
        Object.defineProperty(this, "handleSuccessRegistration", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.registrationFormSubmitted = true;
                this.props.onSuccessRegistration();
            }
        });
        Object.defineProperty(this, "handleRedirectRegistration", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.registrationFormSubmitted = true;
                this.props.onRedirectRegistration();
            }
        });
        Object.defineProperty(this, "handleSuccessLogin", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.loginFormSubmitted = true;
                this.props.onSuccessLogin();
            }
        });
        Object.defineProperty(this, "handleRedirectLogin", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.loginFormSubmitted = true;
                this.props.onRedirectLogin();
            }
        });
        Object.defineProperty(this, "handleCloseRegistration", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.registrationFormSubmitted = true;
                this.props.onCloseRegistration();
            }
        });
        Object.defineProperty(this, "handleCloseLogin", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.loginFormSubmitted = true;
                this.props.onCloseLogin();
            }
        });
        Object.defineProperty(this, "handleErrorRegistration", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (reason) => {
                if (reason && reason.id) {
                    this.setState({
                        currentTab: 1
                    });
                }
                this.props.onErrorRegistration(reason);
            }
        });
        Object.defineProperty(this, "componentWillUnmount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { onCloseLogin, onCloseRegistration } = this.props;
                const { currentTab } = this.state;
                if (currentTab === 0 && !this.registrationFormSubmitted) {
                    onCloseRegistration();
                }
                else if (currentTab === 1 && !this.loginFormSubmitted) {
                    onCloseLogin();
                }
            }
        });
        this.loginFormSubmitted = false;
        this.registrationFormSubmitted = false;
        this.state = {
            currentTab: this.props.currentTab || 0
        };
    }
    componentDidMount() {
        // if (!!this.props.hotjar) {
        //   this.props.hotjar.event('LOGIN_REGISTRATION_MODAL');
        // }
    }
    render() {
        const { t, onErrorLogin, onResetPassword, isSale, language, showCloseButton, onCloseModal, closeButtonClassName, titleId, dragHandleProps } = this.props;
        const { currentTab } = this.state;
        const email = registrationForm.$('email').values();
        // <button>, not <span onClick> — natively Tab-focusable and activates its onClick on both
        // Enter and Space with no extra keydown handling, so there's exactly one code path that
        // can ever fire onCloseModal (no risk of a keydown handler AND a click handler both
        // firing on the same Enter/Space press). type='button' so it never accidentally submits
        // RegistrationForm/LoginForm if it ever ends up inside a <form>.
        const closeButton = showCloseButton ? (React.createElement("button", { type: "button", className: classnames(baseModalStyles.closeButtonCheckout, baseModalStyles.closeButtonCheckoutInline, closeButtonClassName), onClick: onCloseModal, "aria-label": t('AuthRegisterPage:close') },
            React.createElement("svg", { width: "14", height: "14", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true" },
                React.createElement("path", { d: "M0.900391 0.899994L14.9004 14.9M14.9004 0.899994L0.900391 14.9", stroke: "#5B6B7F", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })))) : null;
        return (React.createElement(React.Fragment, null, currentTab === 0 ? (React.createElement(React.Fragment, null,
            React.createElement("h3", { id: titleId, className: styles.titleCheckout, ...dragHandleProps },
                t('CheckoutPage:onlineCheckoutModal.loginRegisterTitle'),
                closeButton),
            React.createElement("div", { className: styles.checkoutFormContent },
                !isSale && (React.createElement("span", { className: `${styles.desc} ${styles.descCenter}` },
                    t('CheckoutPage:onlineCheckoutModal.desc'),
                    React.createElement("span", { className: styles.tabItem, onClick: this.onChangeToLogin }, t('CheckoutPage:onlineCheckoutModal.descOption')))),
                React.createElement(RegistrationForm, { t: t, onSuccess: this.handleSuccessRegistration, onError: this.handleErrorRegistration, onClose: this.handleCloseRegistration, onRedirect: this.handleRedirectRegistration, isSale: isSale, lang: language })))) : (React.createElement(React.Fragment, null,
            React.createElement("h3", { id: titleId, className: styles.titleCheckout, ...dragHandleProps },
                t('CheckoutPage:onlineCheckoutModal.registerTitle'),
                closeButton),
            React.createElement("div", { className: styles.checkoutFormContent },
                React.createElement("span", { className: styles.desc },
                    t('CheckoutPage:onlineCheckoutModal.registerDesc'),
                    React.createElement("span", { className: styles.tabItem, onClick: this.onChangeToCreateAccount }, t('CheckoutPage:onlineCheckoutModal.registerDescOption'))),
                React.createElement(LoginForm, { t: t, 
                    // email={email}
                    onSuccess: this.handleSuccessLogin, onRedirect: this.handleRedirectLogin, onError: onErrorLogin, onClose: this.handleCloseLogin, onResetPassword: onResetPassword }))))));
    }
}
export default LoginRegistrationModal;
